import { RootState } from 'store'

export const versionApi = (state: RootState) => state.versionApi
